webpackJsonp([19853164899746],{

/***/ 1335:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Danny Sperry","slug":"blog/author/danny-sperry","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/danny-sperry"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-danny-sperry-faef2287a0cd57b60862.js